export default __webpack_public_path__ + "static/media/level-7.3575b87a.png";